import { GridActionsCellItem, GridColumns, GridRowParams } from '@mui/x-data-grid-premium';
import { dateFilterOperators, filterOperators } from '../../../../constants';
import { useTranslation } from 'react-i18next';
import { baseCell } from '../cells/base-cell';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import ConfirmationDeleteTableDialog from 'components/helpers/ConfirmationGridDelete';
import { isTenantAdministrator } from 'components/helpers/IsTenantAdministrator';

export function DocumentColumns(
  handleDownload?: (row: any) => void,
  handleDelete?: (id: number) => void
): GridColumns {
  const { t } = useTranslation();
  const isTenantAdminRoles = isTenantAdministrator();

  const columns: GridColumns = [
    {
      field: 'name',
      headerName: t(`global.name`),
      filterOperators,
      width: 150,
      renderCell: baseCell
    },
    {
      field: 'category',
      headerName: t(`pages.document.add.category`),
      filterOperators,
      width: 150,
      renderCell: baseCell
    },
    {
      field: 'tipology',
      headerName: t(`pages.document.add.tipology`),
      filterOperators,
      width: 150,
      renderCell: baseCell
    },
    {
      field: 'supplier',
      headerName: t(`global.supplier`),
      filterOperators,
      width: 150,
      renderCell: baseCell
    },
    {
      field: 'warehouse',
      headerName: t(`global.warehouse`),
      filterOperators,
      width: 150,
      renderCell: baseCell
    },
    {
      field: 'description',
      headerName: t(`global.description`),
      filterOperators,
      width: 400,
      renderCell: baseCell
    },

    {
      field: 'upload_date',
      headerName: t(`pages.document.upload_date`),
      filterOperators: dateFilterOperators,
      width: 200,
      renderCell: baseCell
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: t(`global.actions`),
      getActions: (params: GridRowParams) => {
        const actions = [];
        actions.push(
          <GridActionsCellItem
            key={998}
            icon={<CloudDownloadIcon />}
            onClick={() => handleDownload(params.row)}
            label="Download"
          />
        );
        if (isTenantAdminRoles) {
          actions.push(
            <ConfirmationDeleteTableDialog handleDelete={handleDelete} id={params.row.id} />
          );
        }

        return actions;
      }
    }
  ];

  return columns;
}
